import { type MouseEventHandler, useState } from 'react';
import videoCall from 'assets/category_cards/communicate/video_call.png';
import { useSelectedLinkContext } from 'contexts';
import { type LinkMetadata, VideoCallDisabledReasonsType } from 'types';
import { MenuCategory } from 'layouts/MenuGridPageLayout';
import VideoCallCategoryDisabledOverlay from './VideoCallCategoryDisabledOverlay';

type VideoCallCategoryProps = {
  handleVideoCallClick: MouseEventHandler;
};

const VideoCallCategory = ({ handleVideoCallClick } : VideoCallCategoryProps) : JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();
  const [showOverlay, toggleOverlay] = useState<boolean>(false);

  const getDisabledReason = () : VideoCallDisabledReasonsType | undefined => {
    const linkMetadata : LinkMetadata | undefined = selectedLink?.metadata;
    if (!linkMetadata?.hasMinimalAndroidVersionForVideoCall) {
      return VideoCallDisabledReasonsType.MINIMAL_ANDROID_VERSION;
    }
  
    if (!linkMetadata?.hasMinimalArdoizCoreVersionForVideoCall) {
      return VideoCallDisabledReasonsType.MINIMAL_ARDOIZ_CORE_VERSION;
    }
  };

  const isDisabled = (): boolean => {
    const linkMetadata : LinkMetadata | undefined = selectedLink?.metadata;
    return !linkMetadata?.hasMinimalAndroidVersionForVideoCall || !linkMetadata?.hasMinimalArdoizCoreVersionForVideoCall;
  }

  const disabledReason = getDisabledReason();

  const handleMouseOver = () => toggleOverlay(true);

  const handleMouseLeave = () => toggleOverlay(false);

  return (
    <MenuCategory
      altId='category.communicate.subcategory.visio'
      md={6}
      image={videoCall}
      onClick={event => {
        if (!isDisabled()) handleVideoCallClick(event);
      }}
      onMouseOver={handleMouseOver}
    >
      <VideoCallCategoryDisabledOverlay
        disabledReason={disabledReason}
        showOverlay={showOverlay}
        onMouseLeave={handleMouseLeave}
      />
    </MenuCategory>
  );
};

export default VideoCallCategory;